<template>
  <div ref="el" class="multiple-selection-component rank-component question-type-component">
    <div class="hint-text" v-if="$props.question.hint" v-html="$props.question.hint.get()"></div>
    <div class="sortable-options">
      <template v-for="(option, i) in $props.question.options" v-if="sorted">
        <rank-option @input="onChangeOptions" :option="option" :submission="submission" />
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import QualityMentoringFormQuestion from '../../models/QualityMentoringFormQuestion';
import { getCurrentInstance, nextTick, onMounted, onUnmounted, ref } from 'vue';
import Sortable from 'sortablejs';
import RankOption from './RankOption.vue';

const el = ref();

const props = defineProps({
  question: QualityMentoringFormQuestion,
  submission: Object
})

if(!props.submission['root']) {
  props.submission['root'] = {};
}

if(!props.submission['root'][props.question.path]) {
  props.submission['root'][props.question.path] = {};
}

if (Array.isArray(props.submission['root'][props.question.path]) && props.submission['root'][props.question.path].length === 0) {
  props.submission['root'][props.question.path] = {};
}

if(!props.submission.root.meta) {
  props.submission.root.meta = {};
}

if(!props.submission.root.meta[props.question.path]) {
  props.submission.root.meta[props.question.path] = {};
}

const instance = getCurrentInstance();
const sorted = ref(false);

const getSortableValue = () => {
  const order = [];
  if(!el.value) {
    return;
  }
  const sortableEl = el.value.querySelector('.sortable-options')
  for(const child of sortableEl.children) {
    const value = child.getAttribute('data-value');
    order.push(value);
  }
  return order;
}

const onChangeOptions = async () => {
  await nextTick();
  props.submission['root'][props.question.path] = getSortableValue();
  updateNumber();
  instance.emit('hasChanged');
}

let sortable;

onMounted(async () => {
  if(props.submission['root'][props.question.path]) {
    const order = props.submission['root'][props.question.path];
    if(Array.isArray(order)) {
      props.question.options = props.question.options.sort((a, b) => {
        const aValue = order.indexOf(a.value.toString());
        const bValue = order.indexOf(b.value.toString());
        if(aValue > bValue) {
          return 1;
        } else if(aValue < bValue) {
          return -1;
        }
        return 0;
      });
    }
  }
  sorted.value = true;

  const sortableEl = el.value.querySelector('.sortable-options')
  sortable = Sortable.create(sortableEl, {
    animation: 150,
    ghostClass: 'sortable-ghost',
    dragClass: 'sortable-drag',
    onUpdate: function (e) {
      props.submission['root'][props.question.path] = getSortableValue();
      updateNumber();
      instance.emit('hasChanged');
    },
  });

  await nextTick();
  if(!Object.keys(props.submission['root'][props.question.path]).length) {
    props.submission['root'][props.question.path] = getSortableValue();
    instance.emit('hasChanged');
  }
  updateNumber();
});

onUnmounted(() => {
  sortable.destroy();
});

const updateNumber = () => {
  if(!el.value) return;

  const sortableEl = el.value.querySelectorAll('.rank-option');
  sortableEl.forEach((el, i) => {
    el.querySelector('.rank-order').innerHTML = i + 1;
  })
}

function clear() {
  if(props.submission['root']) {
    delete props.submission['root'][props.question.path];
  }
}

defineExpose({
  clear
})
</script>

<style lang="scss" scoped>
.sortable-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
